import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider, useAuth } from '@/lib/auth';
import { Toaster } from '@/components/ui/sonner';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import WhatsAppButton from '@/components/layout/WhatsAppButton';
import HomePage from '@/pages/HomePage';
import CategoriesPage from '@/pages/CategoriesPage';
import CategoryDetailPage from '@/pages/CategoryDetailPage';
import ReviewPage from '@/pages/ReviewPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ForceResetPasswordPage from '@/pages/ForceResetPasswordPage';
import OrderSuccessPage from '@/pages/OrderSuccessPage';
import AdminDashboard from '@/pages/AdminDashboard';
import ProfilePage from '@/pages/ProfilePage';
import OrdersPage from '@/pages/OrdersPage';

function StaffRoute({ children }) {
  const { isStaff, isAuthenticated, loading } = useAuth();
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isStaff) return <Navigate to="/" replace />;
  return children;
}

function MainShell() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  // Task-focused flows (customization, review) hide the marketing footer so the sticky
  // action bar at the bottom of the viewport doesn't overlap it.
  const hideFooter = /^\/(categories\/[^/]+|review)$/.test(location.pathname);

  // Scroll to top on every route change
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className={`flex-1 ${isHome ? '' : 'pt-[72px]'}`}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/categories/:slug" element={<CategoryDetailPage />} />
          <Route path="/review" element={<ReviewPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/force-reset" element={<ForceResetPasswordPage />} />
          <Route path="/order-success" element={<OrderSuccessPage />} />
          <Route path="/admin" element={<StaffRoute><AdminDashboard /></StaffRoute>} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/about" element={<div className="max-w-3xl mx-auto px-4 py-16 text-center"><h1 className="font-display text-3xl font-bold mb-4">About Besq</h1><p className="text-muted-foreground">Premium custom tailoring, crafted with care and delivered to your doorstep. We believe every garment should be made to fit you perfectly.</p></div>} />
        </Routes>
      </main>
      {!hideFooter && <Footer />}
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <MainShell />
        <Toaster position="top-center" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
